import { Trans, defaultNS, useTranslation } from "@/lib/i18n";
import type { ReactNode } from "react";
import HStack from "../Layout/HStack";

export default function FilterTrans(props: {
  /**
   * フィルタの主語にあたるもの
   * （例：アプリ, 拠点）
   */
  sub: ReactNode;
  /**
   * フィルタの種類
   */
  type: "contains" | "is";
  /**
   * フィルタの目的語にあたるもの
   * （例：Slack, 東京）
   */
  obj: ReactNode;
}) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "component.filterTrans",
  });

  return (
    <HStack className="items-center gap-1">
      <Trans
        t={t}
        i18nKey={props.type}
        components={{
          sub: <>{props.sub}</>,
          obj: <>{props.obj}</>,
          muted: <span className="text-muted-foreground" />,
        }}
      />
    </HStack>
  );
}
